<template>
  <div>
    <x-org-heading heading="Users and Groups">
      <template slot="org-page-button">
        <x-button
          v-if="canManageSystem"
          color="#58E2C2"
          buttonText="Add a new account"
          class="w-auto ml-4"
          :clickFunction="addUser"
          :data-test-id="`${dataTestId}__add-account-btn`"
        />
      </template>
    </x-org-heading>
    <x-tabs
      class="d-flex flex-row my-4"
      :disableAll="loading"
      :tabs="userSummaryHeadLabel"
      :data-test-id="`${dataTestId}__user-status-tabs`"
      @getSelected="selectedTab"
    />
    <user-table
      :currentOrgId="currentlySelectedOrgId"
      :reloadUsers="reloadUsers"
      :editUser="editUser"
      :userStatuses="userStatuses"
      :getCount="getCount"
      :loading="loading"
      :data-test-id="`${dataTestId}__users-table`"
      @toggleUserLoadingState="toggleUserLoadingState"
    />
    <AddNewUser
      v-if="showAddUserOverlay"
      :addUserDialog="showAddUserOverlay"
      :data-test-id="`${dataTestId}__add-user-dialog`"
      @closeOverlay="closeOverlayAndRefresh"
    />
    <EditUser
      v-if="showEditUserOverlay"
      :editUserDialog="showEditUserOverlay"
      :userDetails="userDetails"
      :data-test-id="`${dataTestId}__edit-user-dialog`"
      @closeOverlay="closeOverlayAndRefresh"
    />

    <loader v-if="overlay" />
  </div>
</template>

<script>
import EventBus from '@/EventBus';
const AddNewUser = () => import('./AddNewUserDialogue');
const EditUser = () => import('./EditUserDialogue');
import UserService from '@/services/UserService';
const UserTable = () => import('./UserTable.vue');
export default {
  data() {
    return {
      loading: true,
      overlay: false,
      loaderMesage: '',
      reRender: false,
      componentKey: 0,
      reloadUsers: false,
      showArchivedUsers: false,

      userStatuses: ['ACTIVE'],
      userDetails: null,
      showAddUserOverlay: false,
      showEditUserOverlay: false,

      userSummary: false,
      userSummaryHead: 'Account Summary',
      userSummaryHeadLabel: [
        { subTitle: 'Active', title: '', isSelected: true },
        { subTitle: 'Disabled', title: '' },
        { subTitle: 'Archived', title: '' }
      ],
      dataTestId: 'configuration__users-groups'
    };
  },
  props: ['title'],
  components: {
    AddNewUser,
    EditUser,
    UserTable
  },
  mounted() {
    // custom setting for field.
    // maybe will implement a better way in future

    this.getCount();
    EventBus.$on('TOGGLE_VALUE', () => {
      this.openArchivedUsers();
    });
  },
  computed: {
    getName(rowData) {
      return this.titleCase(rowData.firstName + ' ' + rowData.lastName);
    },
    canManageSystem() {
      return this.$can('manage', 'system');
    },
    canManageUsers() {
      if (this.orgId === this.currentlySelectedOrgId) {
        // wants to view own org users
        return this.$can('manage', 'user');
      } else {
        // wants to view child org users
        return this.$can('manage', 'child_organisation_user');
      }
    }
  },

  methods: {
    selectedTab(data) {
      if (data.status) {
        const hasSameItem = this.userStatuses.find(
          item => item === this.userSummaryHeadLabel[data.index].id
        );
        if (!hasSameItem) {
          this.userStatuses.push(this.userSummaryHeadLabel[data.index].id);
        }
      } else {
        if (this.userStatuses.length > 1) {
          this.userStatuses = this.userStatuses.filter(
            item => item !== this.userSummaryHeadLabel[data.index].id
          );
        } else {
          this.userStatuses = [];
        }
      }
      this.reloadUsers = true;

      this.$nextTick(() => {
        this.reloadUsers = false;
      });
    },

    toggleUserLoadingState(currentState) {
      this.loading = currentState;
    },
    openArchivedUsers() {
      this.currentPage = 1;
      this.reRender = true;
      this.showArchivedUsers = !this.showArchivedUsers;

      this.reloadUsers = true;
      this.$nextTick(() => {
        this.reloadUsers = false;
      });
    },
    async getUserDetails(userId) {
      let userDetails = await UserService.userDetails(userId);
      if (!userDetails || !(userDetails && userDetails.data)) {
        return false;
      }
      if (!userDetails.data.body.length) {
        return false;
      }
      this.userDetails = userDetails.data.body[0].user;
      this.showEditUserOverlay = true;
    },

    addUser() {
      this.showAddUserOverlay = true;
    },
    editUser(userId) {
      if (!this.$can('manage', 'user')) {
        return;
      }
      this.overlay = true;
      this.getUserDetails(userId).then(() => {
        if (
          this.userDetails.groupMembers &&
          this.userDetails.groupMembers.length
        ) {
          this.addUserDetails(this.userDetails.groupMembers).then(() => {
            this.overlay = false;
            this.showEditUserOverlay = true;
          });
        } else {
          this.overlay = false;
          this.showEditUserOverlay = true;
        }
      });
    },
    closeOverlayAndRefresh(data) {
      this.showAddUserOverlay = false;
      this.showEditUserOverlay = false;
      if (data.refreshUsers) {
        this.reloadUsers = true;
        this.$nextTick(() => {
          this.reloadUsers = false;
        });
      }
      if (data.refreshSummary) {
        this.getCount();
      }
    },
    async getCount() {
      try {
        let groupCount = await UserService.getUserInfo('userCounts', {
          orgId: this.currentlySelectedOrgId
        });
        let data = groupCount.data.body[0];
        this.userSummaryHeadLabel = [
          {
            subTitle: 'Active',
            title: data.active,
            isSelected: true,
            id: 'ACTIVE'
          },
          { subTitle: 'Disabled', title: data.disabled, id: 'DISABLED' },
          { subTitle: 'Archived', title: data.archived, id: 'ARCHIVED' }
        ];
      } catch (err) {
        this.snackbar('error', err);
      }
    }
  }
};
</script>
